<template>
  <div class="">
    <div class="">
      <div class="">
        <div class="">
          <div>
            <div class="font-bold text-xl pt-2 lg:pt-0 text-[#09518C]">
              Employees List
            </div>
          </div>
          <div class="xl:flex justify-between items-center mb-3">
            <div class="text-sm bg-[#E3FEEC] w-fit px-2 py-1 rounded mt-1">
              All Employees
            </div>
            <div
              class="lg:flex gap-3 justify-end lg:justify-between lg:mt-2 xl:mt-0"
            >
              <div
                class="flex items-center text-gray-500 border shadow pl-3 mt-3 lg:mt-0"
              >
                <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                <input
                  :disabled="error !== null"
                  v-model="filter"
                  class="appearance-none w-full border-none rounded py-2 px-2 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="search"
                />
              </div>
              <div
                class="flex items-center border shadow pl-3 text-gray-500 mt-3 lg:mt-0"
              >
                <font-awesome-icon icon="fa-solid fa-filter" />
                <select
                  v-model="selectFilter"
                  class="border-none cursor-pointer appearance-none w-full border rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                >
                  <option value="">All</option>
                  <option value="Funded">Funded</option>
                  <option value="Unfunded">Unfunded</option>
                </select>
              </div>
              <button
                :disabled="!displayedStaffs"
                @click="downloadFile()"
                class="bg-[#8dc63f] hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300 py-1.5 lg:py-0 w-full lg:w-fit px-4 rounded-lg text-white text-sm lg:text-sm xl:text-base cursor-pointer mt-3 lg:mt-0"
              >
                Export to Excel
              </button>
            </div>
          </div>
        </div>

        <LoadingSpinner v-if="loading === true" />

        <div
          v-if="error"
          class="bg-red-600 text-white text-center my-3 rounded-md p-4"
        >
          <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
          {{ error }}
        </div>

        <div
          class="overflow-x-auto overflow-y-hidden w-full"
          v-if="loading === false && !error"
        >
          <TableComponent
            :columns="tableColumns"
            :data="displayedStaffs"
            :renderCell="customRenderCell"
          >
            <template v-slot:actions="{ item }">
              <router-link :to="`employee-details/${item.pin}`">
                <font-awesome-icon
                  class="hover:text-gray-600 group relative duration-300 text-green-600"
                  style="cursor: pointer"
                  icon="eye"
                />
                <span
                  class="absolute hidden group-hover:flex -top-2 -right-3 translate-x-full w-48 px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-sm before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-8 before:border-y-transparent before:border-l-transparent before:border-r-gray-700"
                  >View details</span
                >
              </router-link>
              <font-awesome-icon
                @click="getStaffAndOpenModal(item)"
                class="ml-2 text-[#09518c] hover:text-gray-600"
                style="cursor: pointer"
                icon="times-circle"
              />
            </template>
          </TableComponent>
        </div>

        <div class="text-sm text-gray-600"></div>
        <div class="py-8"></div>
      </div>
    </div>

    <EmployeeListModal
      :getContact="getContact"
      :isModalVisible="isModalVisible"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";
import exportFromJSON from "export-from-json";
import { useStore } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import EmployeeListModal from "@/components/modals/EmployeeListModal.vue";
import TableComponent from "@/components/TableComponent.vue";
export default {
  components: {
    LoadingSpinner,
    EmployeeListModal,
    TableComponent,
  },
  setup() {
    const store = useStore();
    const staffs = computed(() => store.state.employeeList);
    const filtered = ref([]);
    const loading = computed(() => store.state.employeesLoaded);
    const page = ref(1);
    const perPage = ref(20);
    const search = ref("");
    const selectFilter = ref("");
    const filter = ref("");
    const getSearchedStaff = ref([]);
    const isModalOpen = ref(false);
    const getContact = ref("");
    const exitLoading = ref(false);
    const errortoggle = ref(false);
    const error = computed(() => store.state.error);
    // console.log(error, "error");
    const tableColumns = ref([
      { key: "pin", label: "RSA PIN", className: "px-2 py-2" },
      { key: "first_name", label: "Name", className: "px-2 py-2" },
      { key: "fund", label: "Fund Type", className: "px-2 py-2" },
      { key: "status", label: "Funding Status", className: "px-2 py-2" },
      { key: "old_pfa_code", label: "Previous PFA", className: "px-2 py-2" },
      { key: "upload_date", label: "Date Joined", className: "px-2 py-2" },
      { key: "actions", label: "Actions", className: "px-2 py-2", link: "no" },
    ]);

    const isModalVisible = computed(() => isModalOpen.value);

    const closeModal = () => {
      isModalOpen.value = false;
    };

    const getStaffAndOpenModal = (contact) => {
      getContact.value = contact;
      isModalOpen.value = !isModalOpen.value;
    };

    const downloadFile = () => {
      const data =
        filter.value === "" || selectFilter.value === ""
          ? staffs.value
          : getSearchedStaff.value;
      const fileName = `employee-list-${store.state.getLoggedInUser.name}`;
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({ data, fileName, exportType });
    };

    const customRenderCell = (item, column) => {
      if (column.key === "first_name") {
        return item?.first_name + " " + item?.last_name;
      }

      if (column.key === "old_pfa_code") {
        return staffs.value?.old_pfa_code !== ""
          ? staffs.value?.old_pfa_code
          : "-";
      }

      return item[column.key];
    };

    const displayedStaffs = computed(() => {
      // const startIndex = perPage.value * (page.value - 1);
      // const endIndex = startIndex + perPage.value;

      let filteredStaffs = staffs.value;

      if (selectFilter.value === "Unfunded") {
        filteredStaffs = filteredStaffs.filter((staff) =>
          staff.status.includes("Unfunded")
        );
      } else if (selectFilter.value === "Funded") {
        filteredStaffs = filteredStaffs.filter((staff) =>
          staff.status.includes("Funded")
        );
      }

      if (filter.value.length > 1) {
        const searchTerm = filter.value.toLowerCase();
        const searchParts = searchTerm.split(" ");

        filteredStaffs = filteredStaffs.filter((staff) => {
          return searchParts.every(
            (part) =>
              staff.first_name.toLowerCase().includes(part) ||
              staff.last_name.toLowerCase().includes(part) ||
              staff.pin.includes(part)
          );
        });
      }

      getSearchedStaff.value = filteredStaffs;
      return filteredStaffs;
    });

    return {
      staffs,
      loading,
      page,
      displayedStaffs,
      downloadFile,
      search,
      filter,
      isModalOpen,
      getContact,
      getStaffAndOpenModal,
      exitLoading,
      isModalVisible,
      errortoggle,
      perPage,
      filtered,
      error,
      customRenderCell,
      tableColumns,
      selectFilter,
      getSearchedStaff,
      closeModal,
    };
  },
};
</script>

<style scoped>
tbody tr {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
}
</style>

<style>
ul {
  display: flex;
}

ul li:first-child(1),
ul li:nth-last-child(1) {
  display: flex;
}

.active {
  background: white;
  color: #404040;
}

li {
  margin-right: 10px;
  /* --tw-bg-opacity: 1; */
  background: #09518c;
  color: white;
  border: 1px solid #404040;
  border-radius: 999px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 17px;
  width: 37px;
  text-align: center;
}

.VuePagination__pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.VuePagination__count,
.VuePagination__count {
  text-align: center;
  color: #09518c;
  font-size: 14px;
  margin-top: 5px;
}
</style>
